import RecommendedSubTable from '../RecommendedMedicalsTable/RecommendedSubTable';
import AlternativeSubTable from '../RecommendedMedicalsTable/AlternativeSubTable';
import { BasicInformation } from '../BasicInformation';
import { useSnackbar } from 'notistack';
import styles from './styles';
import RecommendationText from './RecommendationText';

const RecommendedMedicalsTable = ({ config, props }) => {
    const { booking, patient, recommendation } = props;
    const { recommended_medicals, alternate_medical_services, services, care_activity, episode_of_care } =
        recommendation;
    const classes = styles();
    const { enqueueSnackbar } = useSnackbar();
    if((recommended_medicals || []).length ===0 && (alternate_medical_services || []).length ===0){
        enqueueSnackbar("No recommendations available", { variant: 'error' })
    }
    return (
        <>
            <div style={{ padding: '15px' }}>
                <BasicInformation patient={patient} booking={booking} />
            </div>
            <div>
                <RecommendationText
                    medicalType={booking.consult_type}
                    disease={booking.metadata?.disease_type}
                />
            </div>
            <div className={classes.tableDiv}>
                <RecommendedSubTable
                    booking={booking}
                    patient={patient}
                    activityId={care_activity?.activity_id}
                    data={recommended_medicals || []}
                    episodeOfCareId={episode_of_care?.episode_of_care_id}
                />
                <AlternativeSubTable
                    booking={booking}
                    patient={patient}
                    activityId={care_activity?.activity_id}
                    data={alternate_medical_services || []}
                    episodeOfCareId={episode_of_care?.episode_of_care_id}
                />
            </div>
        </>
    );
};

export default RecommendedMedicalsTable;
